import AddIcon from '@material-ui/icons/Add'

export default {
  add: AddIcon,
}
